<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel" :width="610" >
      <h3 slot="header" class="modal-header">查看确认单</h3>
      <div>
        <Form :model="formData" :label-width="120"  ref="formData" >
          <FormItem label="项目">
            <div>{{formData.projectName}}</div>
          </FormItem>
          <FormItem label="签约管家" prop="zoName" class="">
            <div>{{formData.zoName}}</div>
          </FormItem>
          <FormItem label="客户姓名" prop="customerName" class="">
            {{formData.customerName}}
          </FormItem>
          <FormItem label="联系方式" prop="customerPhone" class="">
            {{formData.customerPhone}}
          </FormItem>
          <FormItem label="合同号" prop="contractCode" class="">
            {{formData.contractCode}}
          </FormItem>
          <FormItem label="房间号" prop="stockNum"  >
            <div>{{formData.stockNum}}</div>
          </FormItem>
          <FormItem label="月租金" prop="monthPrice" class="">
            <div>{{formData.monthPrice}}</div>
          </FormItem>
          <FormItem label="总租金" prop="totalPrice" class="">
            <div>{{formData.totalPrice}}</div>
          </FormItem>
          <FormItem label="平台服务费" prop="servicePrice" class="">
            <div>{{formData.servicePrice}}</div>
          </FormItem>
          <FormItem label="合同租期"  prop="dateList" class="item-width">
            {{formData.conStartDate}}-{{formData.conEndDate}}
          </FormItem>
          <FormItem label="签约日期" prop="conSignDate">
            {{formData.conSignDate}}
          </FormItem>
          <FormItem label="合同照片" prop="contractPic" class="">
            <div style="display: flex;flex-wrap: wrap">
              <template v-for="item in formData.pics " v-if="formData.pics">
                <div class="fileItem">
                  <div style="margin-bottom: 10px;">
                    <img class="file-img" :src="item.url" alt="" @click="showImg(item.url)">
                  </div>
                </div>
              </template>
            </div>
          </FormItem>
        </Form>
      </div>
    </Modal>
    <img-show :src="imgSrc" :n="showImgKey"></img-show>
  </div>

</template>
<script>

  import {formatDateTime} from "../../../utils/format";
  import {saveOrUpdate,findOrderListById} from "../../../api/confirmOrder";
  import { fuzzyRoom } from '../../../api/functionalArea';
  import ImgShow from 'components/ImgShow/index';
  export default {
    name: "ViewConfirmOrderForm"   ,
    components:{
      ImgShow
    },
    created() {

    },
    props:{
      n:{
        type:Number,
        default:0
      },
      confirmOrderFid:{
        type:String,
        default:''
      },
      businessFid:{
        type:String,
        default:''
      },


    },
    watch:{
      n(val){
        this.$refs['formData'].resetFields();
        this.isShow = true;
        this.findConfirmOrderInfo();

      },
    },
    data(){
      return {
        loading: true,
        isShow:false,
        pics:[],
        showImgKey:0,
        imgSrc:"",
        dateList:[],
        formData:{
            "projectFid":"",
            "projectName":"",
          "businessFid":"",
          "customerName":"",
          "customerPhone":"",
          "contractCode":"",
          "stockNum":"",
          "totalPrice":0,
          "conStartDate":"",
          "conEndDate":"",
          "conSignDate":"",
          "zoName":"",
          "zoFid":"",
          "pics":[],
          "dateList":[],
          "monthPrice":0,
          "servicePrice":0
        },
      }
    },
    methods:{
      clearData(){
        this.formData={
          "projectFid":"",
          "projectName":"",
          "businessFid":"",
          "customerName":"",
          "customerPhone":"",
          "contractCode":"",
          "stockNum":"",
          "totalPrice":0,
          "conStartDate":"",
          "conEndDate":"",
          "conSignDate":"",
          "zoName":"",
          "zoFid":"",
          "fid":"",
        }

        this.$refs['formData']  && this.$refs['formData'].resetFields()


      },
      validateDate(rule, value, callback) {
        if (!value[0] || !value[1]) {
          callback(new Error('请选择日期'));
        }
        callback();
      },
      changeLoading() {

      },
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)
      },
      ok(){
        this.isShow=false
      },
      cancel(){

      },
      findConfirmOrderInfo(){
        findOrderListById(this.confirmOrderFid,this.businessFid).then(res => {
          this.formData=res.data;
          this.formData.dateList=[res.data.conStartDate,res.data.conEndDate];
        }).catch(error=>{})
      },
      showImg(data) {
        this.imgSrc = data
        this.showImgKey++
      }
    }

  }
</script>

<style scoped>
  .item-width{
    width: 280px;
  }


</style>
